import jsonToJsxComponent from '../jsonToJsxComponent';
import FaqQuestionJson from './FaqQuestion.json';

const FaqQuestion = jsonToJsxComponent(FaqQuestionJson);

// eslint-disable-next-line import/prefer-default-export
export { FaqQuestion };
